import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `https://17chigua.com${item.href}` : `https://17chigua.com${window.location.pathname}`,
        name: item.label,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm font-label text-foreground-500">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs w-4 h-4 flex items-center justify-center"></i>
            )}
            {item.href && index < items.length - 1 ? (
              <Link
                to={item.href}
                className="hover:text-primary-600 transition-colors duration-200"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}